import * as TICKETS from './tickets.constants';
import { Ticket } from '../../models';

/** LOAD */
export function loadTickets() {
    return { type: TICKETS.TICKETS_LOAD };
}

export function loadTicketsSuccess(data: Ticket[]) {
    return { type: TICKETS.TICKETS_LOAD_SUCCESS, payload: data };
}

export function loadTicketsError(error: any) {
    return { type: TICKETS.TICKETS_LOAD_ERROR, payload: error };
}


/** ADD */
export function addTickets(targetTickets: Ticket[]) {
    return { type: TICKETS.TICKETS_ADD, payload: targetTickets };
}

export function addTicketsSuccess(targetTickets: Ticket[]) {
    return { type: TICKETS.TICKETS_ADD_SUCCESS, payload: targetTickets };
}

export function addTicketsError(error: any) {
    return { type: TICKETS.TICKETS_ADD_ERROR, payload: error };
}


/** UPDATE */
export function updateTickets(targetTickets: Ticket[]) {
    return { type: TICKETS.TICKETS_UPDATE, payload: targetTickets };
}

export function updateTicketsSuccess(targetTickets: Ticket[]) {
    return { type: TICKETS.TICKETS_UPDATE_SUCCESS, payload: targetTickets };
}

export function updateTicketsError(error: any) {
    return { type: TICKETS.TICKETS_UPDATE_ERROR, payload: error };
}


/** DELETE */
export function deleteTickets(ids: number[]) {
    return { type: TICKETS.TICKETS_DELETE, payload: ids };
}

export function deleteTicketsSuccess(tickets: Ticket[]) {
    return { type: TICKETS.TICKETS_DELETE_SUCCESS, payload: tickets };
}

export function deleteTicketsError(error: any) {
    return { type: TICKETS.TICKETS_DELETE_ERROR, payload: error };
}